import React from "react";
import styled from "styled-components";
import { Footer } from "./elements/Footer";


export const AnonymousLayout = ({ title, wide, customControls, children }: React.PropsWithChildren<{
    title?:string,
    wide?:boolean,
    customControls?: React.ReactNode,
}>) => {
    return (

        <Main>
            <HeaderWrapper>
                <HeaderContent wide={wide || false}>
                        
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <LogoWrapper>
                            <img src="/images/amorg_logo_blue.svg" />
                        </LogoWrapper>

                        {title &&
                            <Title>
                                {title}
                            </Title>
                        }
                    </div>

                    {customControls &&
                        <div>
                            {customControls}
                        </div>
                    }

                </HeaderContent>
            </HeaderWrapper>
            <ContentWrapper wide={wide || false}>
                {children}
            </ContentWrapper>
            <FooterWrapper>
                <Footer />
            </FooterWrapper>
        </Main>

    )
};




const maxWidth = 1020;

const Main = styled.div`
    min-height: 100%;
    display: flex;
    flex-direction: column;
`;

const HeaderWrapper = styled.div`
    width: 100%;
    background-color: #f8f8f8;
`;
const HeaderContent = styled.div<{wide?: boolean}>`
    display: flex;
    justify-content: space-between;
    width: 90%;
    ${props => !props.wide && `max-width: ${maxWidth}px;`}
    margin: 0 auto;
`;

const LogoWrapper = styled.div`
    align-self: start;
    height: 50px;
    left: 20px;
    position: sticky;
    top: 20px;
    width: 50px;
    margin: 0;

    img {
        display: block;
    }
`;

const Title = styled.h1`
    font-size: 24px;
    font-weight: 500;
    margin: 0;
    padding: 0 20px;
    align-self: center;
`;

const ContentWrapper = styled.div<{wide:boolean}>`
    background: white;
    padding-bottom:20px;
    width: 90%;
    ${props => !props.wide && `max-width: ${maxWidth}px;`}
    height: max-content;
    margin: 0 auto;
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const FooterWrapper = styled.div`
    margin-top: auto;
`;